var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32.453,
    viewBox: "0 0 32 32.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentcolor",
    id: "noun-teddy-2979514",
    transform: "translate(-0.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M42.43,118.669c-4.168,0-5.727,0-7.241-2.282a.507.507,0,1,1,.844-.563c1.214,1.82,2.312,1.82,6.4,1.82s5.185,0,6.4-1.82a.507.507,0,1,1,.844.563C48.163,118.669,46.6,118.669,42.43,118.669Z",
    transform: "translate(-25.544 -86.29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M33.164,19.424A10.491,10.491,0,0,1,22.69,8.945C22.69,3.6,26.9,0,33.164,0S43.642,3.6,43.642,8.945A10.491,10.491,0,0,1,33.164,19.424Zm0-18.409c-5.743,0-9.46,3.113-9.46,7.931a9.466,9.466,0,0,0,18.932,0C42.636,4.128,38.922,1.014,33.164,1.014Z",
    transform: "translate(-16.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M21.071,6.206a.507.507,0,0,1-.218-.051,3.235,3.235,0,1,1,4.188-4.564.507.507,0,1,1-.875.507A2.221,2.221,0,1,0,21.3,5.243a.507.507,0,0,1-.221.963Z",
    transform: "translate(-13.541 -0.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M89.009,6.224a.507.507,0,0,1-.221-.963A2.221,2.221,0,1,0,85.9,2.137a.507.507,0,1,1-.875-.507A3.235,3.235,0,1,1,89.22,6.181.507.507,0,0,1,89.009,6.224Z",
    transform: "translate(-62.742 -0.023)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M58.564,49.014H54.507a.507.507,0,0,1,0-1.014h4.057a.507.507,0,0,1,0,1.014Z",
    transform: "translate(-39.649 -35.83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M62.507,51.042A.507.507,0,0,1,62,50.535V48.507a.507.507,0,1,1,1.014,0v2.028A.507.507,0,0,1,62.507,51.042Z",
    transform: "translate(-45.621 -35.83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M32.506,83.8a.507.507,0,0,1-.492-.631,6.964,6.964,0,0,1,.859-2.259.507.507,0,1,1,.854.548A5.832,5.832,0,0,0,33,83.417.507.507,0,0,1,32.506,83.8Z",
    transform: "translate(-23.226 -60.223)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M6.727,94.688a5.763,5.763,0,0,1-5.449-4.257h0c-1-4.267-.18-5.9,3.367-6.734,1.722-.4,2.906-.507,3.869.142s1.552,1.9,2.135,4.4c.7,3-.606,5.791-2.979,6.338A4.14,4.14,0,0,1,6.727,94.688ZM2.265,90.2a4.687,4.687,0,0,0,5.175,3.4c1.818-.426,2.789-2.677,2.221-5.127-.507-2.191-1.014-3.324-1.714-3.788s-1.623-.335-3.07,0C2.1,85.332,1.327,86.22,2.267,90.2Z",
    transform: "translate(0 -62.235)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M91.977,94.717a4.115,4.115,0,0,1-.938-.1c-2.381-.558-3.7-3.344-2.994-6.338.583-2.5,1.2-3.775,2.13-4.4s2.15-.545,3.869-.142c3.55.829,4.366,2.467,3.367,6.734h0A5.747,5.747,0,0,1,91.977,94.717Zm-.1-10.3a1.962,1.962,0,0,0-1.133.294c-.69.467-1.2,1.6-1.714,3.788-.573,2.447.411,4.7,2.239,5.127a4.612,4.612,0,0,0,5.157-3.4c.93-3.978.165-4.865-2.609-5.514a8.988,8.988,0,0,0-1.94-.294Zm5.04,5.928Z",
    transform: "translate(-64.921 -62.264)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M13.509,72.322a.507.507,0,0,1-.439-.761A9.708,9.708,0,0,1,20.582,67a.508.508,0,0,1,.056,1.014,8.879,8.879,0,0,0-6.688,4.057A.507.507,0,0,1,13.509,72.322Z",
    transform: "translate(-9.046 -50.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M90.275,83.861a.507.507,0,0,1-.492-.385l-.015-.106a4.977,4.977,0,0,0-.682-1.838.507.507,0,0,1,.839-.568,5.912,5.912,0,0,1,.827,2.163l.028.109a.507.507,0,0,1-.5.626Z",
    transform: "translate(-65.783 -60.282)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M90.606,72.324a.507.507,0,0,1-.446-.254c-.028-.051-2.256-4.057-6.653-4.057a.507.507,0,0,1,0-1.014c5.018,0,7.444,4.389,7.545,4.576a.507.507,0,0,1-.446.748Z",
    transform: "translate(-61.297 -50.013)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlush);
export default __webpack_public_path__ + "static/media/plush.a65e77919a2c435ffa8252febe802fdb.svg";
export { ForwardRef as ReactComponent };